import React, { useEffect } from 'react';
import { NavLink, useNavigate, Outlet } from 'react-router-dom';
import { Shield, LogOut, Home, MessageSquare, Users, Package, TrendingUp, Activity, AlertTriangle, ShoppingCart, Settings, Briefcase, Award, Coins } from 'lucide-react';

const AdminLayout = () => {
  const navigate = useNavigate();
  
  useEffect(() => {
    const isAdminAuth = localStorage.getItem('isAdminAuthenticated');
    if (!isAdminAuth) {
      navigate('/admin/login');
    }
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminUser');
    localStorage.removeItem('isAdminAuthenticated');
    navigate('/admin/login');
  };

  const adminUser = JSON.parse(localStorage.getItem('adminUser') || '{}');

  const navItems = [
    { path: '/admin/dashboard', icon: Home, label: 'Dashboard' },
    { path: '/admin/orders', icon: ShoppingCart, label: 'Orders' },
    { path: '/admin/groups', icon: Users, label: 'Groups' },
    { path: '/admin/jobs', icon: Briefcase, label: 'Jobs' },
    { path: '/admin/skills', icon: Award, label: 'Skills' },
    { path: '/admin/tokens', icon: Coins, label: 'Tokens' },
    { path: '/admin/support', icon: MessageSquare, label: 'Support' },
    { path: '/admin/users', icon: Users, label: 'Users' },
    { path: '/admin/products', icon: Package, label: 'Products' },
    { path: '/admin/analytics', icon: TrendingUp, label: 'Analytics' },
    { path: '/admin/system', icon: Activity, label: 'System' },
    { path: '/admin/security', icon: Shield, label: 'Security Logs' },  
    { path: '/admin/settings', icon: Settings, label: 'Settings' },
  ];

  return (
    <div className="min-h-screen bg-gray-100 flex">
      {/* Sidebar */}
      <div className="w-64 bg-gray-900 text-white">
        <div className="p-4 border-b border-gray-800">
          <div className="flex items-center">
            <Shield className="w-8 h-8 text-red-500 mr-2" />
            <span className="font-bold">Admin Portal</span>
          </div>
        </div>
        
        <nav className="p-4">
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              onClick={() => console.log('Navigating to:', item.path)}
              className={({ isActive }) => `
                w-full flex items-center p-3 rounded hover:bg-gray-800 mb-2
                ${isActive ? 'bg-gray-800 border-l-4 border-red-500' : ''}
              `}
            >
              <item.icon size={20} className="mr-3" />
              {item.label}
            </NavLink>
          ))}
        </nav>
        
        <div className="absolute bottom-0 w-64 p-4 border-t border-gray-800">
          <div className="mb-3">
            <p className="text-sm">{adminUser.name}</p>
            <p className="text-xs text-gray-400">{adminUser.email}</p>
          </div>
          <button
            onClick={handleLogout}
            className="w-full flex items-center p-2 hover:bg-gray-800 rounded"
          >
            <LogOut size={20} className="mr-2" />
            Logout
          </button>
        </div>
      </div>

      {/* Main Content */}
      <div className="flex-1">
        <Outlet />
      </div>
    </div>
  );
};

export default AdminLayout;